<template>
  <b-card no-body>
    <h6 slot="header" class="mb-0">
      <font-awesome-icon icon="calendar" />แผนการดำเนินงาน
    </h6>

    <div class="event-list">
      <div v-for="(task, index) in value" :key="index" class="event-list-item">
        <div class="d-flex">
          <h6>กิจกรรมที่ {{ index + 1 }}</h6>
          <div class="ml-auto">
            <b-button size="sm" variant="outline-danger" class="mb-2" @click="deleteTask(index)">ลบ</b-button>
          </div>
        </div>
        <b-form-group label-cols-sm="4" label-cols-lg="1" label-size="sm" label="ชื่อกิจกรรม">
          <b-form-input
            v-model.trim="$v.value.$each[index].title.$model"
            :state="$v.value.$each[index].title.$dirty ? !$v.value.$each[index].title.$error : null"
            size="sm"
          />
        </b-form-group>

        <b-form-group label-cols-sm="4" label-cols-lg="1" label-size="sm" label="ช่วงเวลา" class="mb-0">
          <div class="row mb-0">
            <div class="col-5">
              <v-date-picker
                v-model="$v.value.$each[index].datetime.$model"
                :columns="2"
                :popover="{ visibility: 'click' }"
                mode="range"
                color="orange"
                locale="th"
              >
                <input
                  slot-scope="{ inputProps, inputEvents }"
                  type="text"
                  class="form-control form-control-sm"
                  :class="{ 'is-invalid': $v.value.$each[index].datetime.$dirty ? $v.value.$each[index].datetime.$error : false, 'is-valid': !$v.value.$each[index].datetime.$error && $v.value.$each[index].datetime.$model }"
                  v-bind="inputProps"
                  v-on="inputEvents"
                >
              </v-date-picker>
            </div>
            <div class="col-7">
              <b-form-group label-cols-sm="4" label-cols-lg="2" label-size="sm" label="ผู้รับผิดชอบ" class="mb-0">
                <b-form-input
                  v-model.trim="$v.value.$each[index].responsiblePerson.$model"
                  :state="$v.value.$each[index].responsiblePerson.$dirty ? !$v.value.$each[index].responsiblePerson.$error : null"
                  size="sm"
                />
              </b-form-group>
            </div>
          </div>
        </b-form-group>
      </div>

      <b-button size="sm" variant="primary" @click="createTask"><font-awesome-icon icon="plus-circle" />เพิ่มกิจกรรม</b-button>
    </div>
  </b-card>
</template>

<script>
import ProjectEditValidatorMixins from '@/mixins/projectEditValidatorMixins'
import { required } from 'vuelidate/lib/validators'

export default {
  mixins: [ ProjectEditValidatorMixins ],
  props: {
    value: { type: Array, required: true }
  },
  watch: {
    value (newValue) {
      this.$emit('input', newValue)
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.$v.value.$reset()
    })
  },
  methods: {
    createTask () {
      this.value.push({
        title: '',
        datetime: null,
        responsiblePerson: ''
      })
    },
    deleteTask (index) {
      this.$delete(this.value, index)
    },
    resetValidator () {
      this.$v.value.$reset()
    }
  },
  validations: {
    value: {
      $each: {
        title: { required },
        datetime: { required },
        responsiblePerson: { required }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.event-list {
  padding: $card-spacer-x;
}

.event-list-item {
  margin: -$card-spacer-x;
  padding: $card-spacer-x;
  border-bottom: 1px dashed $gray-300;
  margin-bottom: 20px;
}
</style>
